export const DESIGN_TOKENS = {
  borderRadius: {
    sm: 8,   // Small elements like buttons, inputs
    md: 12,  // Default for cards, papers
    lg: 16,  // Large containers
    xl: 24,  // Special containers, modals
  },
  spacing: {
    section: {
      sm: 6,   // theme.spacing(6) = 48px
      md: 8,   // theme.spacing(8) = 64px  
      lg: 12,  // theme.spacing(12) = 96px
      xl: 16,  // theme.spacing(16) = 128px
    }
  },
  shadows: {
    // Only for buttons - other elements should use Material-UI elevation
    button: {
      default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      hover: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      focus: '0 0 0 3px rgba(67, 56, 202, 0.12)',
    }
  }
} as const; 